import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
export function formatConfirmationDateTime(date: string | Date): string {
  return format(utcToZonedTime(date, timezone), "EEEE d MMMM 'at' HH.mm aa");
}